<div class="w-full bg-white border border-[#e5e7eb] relative text-slate-900 px-4 h-full flex flex-col overflow-hidden">
    <!-- Header -->
    <div class="flex items-center justify-between pt-5 pb-0 border-b border-gray-200 mb-2 shrink-0">
        <h1 class="text-base font-bold text-gray-900 m-0">{{requestDetails ? requestDetails.type: ""}} Request Details
        </h1>
        <button
            class="bg-white outline-none border-none !bg-transparent hover:bg-gray-50 text-gray-400 hover:text-gray-600 !w-8 !h-8 !rounded-md cursor-pointer"
            (click)="closeDrawer()">
            <span class="material-symbols-outlined !text-lg">close</span>
        </button>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto pb-20 mt-0 pr-2" *ngIf="requestDetails && !isLoading">
        <div class="grid grid-cols-2 gap-y-4 gap-x-4 mb-10" *ngIf="fullDetails || requestDetails">
            <!-- Request ID -->
            <div>
                <p class="text-[13px] text-[#808080] mb-2 leading-none font-medium">Request ID</p>
                <div class="flex items-center gap-2">
                    <span class="material-symbols-outlined text-lg text-[#4a4a51] leading-none mb-px">tag</span>
                    <span class="leading-none text-[15px] font-medium text-gray-800">{{ fullDetails?.request_code ||
                        requestDetails?.request_code }}</span>
                </div>
            </div>

            <!-- Status -->
            <div>
                <p class="text-[13px] text-[#808080] mb-2 leading-none font-medium">Status</p>
                <span [ngClass]="getStatusClass(fullDetails?.status || requestDetails?.status)"
                    class="inline-flex items-center px-3 py-1 rounded-full text-[12px] font-semibold border whitespace-nowrap cursor-default select-none leading-none">
                    {{ (fullDetails?.status || requestDetails?.status) == 'in_review' ? 'In Review' :
                    (fullDetails?.status || requestDetails?.status) | titlecase }}
                </span>
            </div>

            <!-- Type -->
            <div>
                <p class="text-[13px] text-[#808080] mb-2 leading-none font-medium">Type</p>
                <div class="flex items-center gap-1">
                    <span class="material-symbols-outlined text-lg text-[#4a4a51] leading-none">
                        {{ (fullDetails?.request_type || requestDetails?.request_type) === 'support' ? 'help_outline' :
                        (fullDetails?.request_type || requestDetails?.request_type) === 'demo' ? 'play_circle' :
                        'chat_bubble_outline' }}
                    </span>
                    <span class="leading-none text-[15px] font-medium text-gray-800">{{ (fullDetails?.request_type ||
                        requestDetails?.request_type) | titlecase }}</span>
                </div>
            </div>

            <!-- Created By -->
            <div>
                <p class="text-[13px] text-[#808080] mb-2 leading-none font-medium">Created By</p>
                <div class="flex items-center gap-2">
                    <span
                        class="material-symbols-outlined text-lg text-[#4a4a51] leading-none mb-px">person_outline</span>
                    <span class="leading-none text-[15px] font-medium text-gray-800">{{ fullDetails?.created_by?.name ||
                        requestDetails?.created_by?.name }}</span>
                </div>
            </div>

            <!-- Contact Name -->
            <div *ngIf="(fullDetails?.request_type || requestDetails?.request_type) !== 'feedback'">
                <p class="text-[13px] text-[#808080] mb-2 leading-none font-medium">Contact Name</p>
                <div class="flex items-center gap-2">
                    <span class="material-symbols-outlined text-lg text-[#4a4a51] leading-none mb-px">person</span>
                    <span class="leading-none text-[15px] font-medium text-gray-800">{{ fullDetails?.contact_name ||
                        'N/A' }}</span>
                </div>
            </div>

            <!-- Phone Number -->
            <div *ngIf="(fullDetails?.request_type || requestDetails?.request_type) !== 'feedback'">
                <p class="text-[13px] text-[#808080] mb-2 leading-none font-medium">Phone Number</p>
                <div class="flex items-center gap-2">
                    <span class="material-symbols-outlined text-lg text-[#4a4a51] leading-none mb-px">phone</span>
                    <span class="leading-none text-[15px] font-medium text-gray-800">{{ fullDetails?.contact_phone ||
                        'N/A' }}</span>
                </div>
            </div>

            <!-- Email -->
            <div *ngIf="(fullDetails?.request_type || requestDetails?.request_type) !== 'feedback'">
                <p class="text-[13px] text-[#808080] mb-2 leading-none font-medium">Email</p>
                <div class="flex items-center gap-2 overflow-hidden">
                    <span
                        class="material-symbols-outlined text-lg text-[#4a4a51] leading-none mb-px shrink-0">email</span>
                    <span class="leading-none text-[15px] font-medium text-gray-800 truncate block max-w-full"
                        [matTooltip]="fullDetails?.contact_email">{{ fullDetails?.contact_email || 'N/A' }}</span>
                </div>
            </div>

            <!-- Source -->
            <div>
                <p class="text-[13px] text-[#808080] mb-2 leading-none font-medium">Source</p>
                <div class="flex items-center gap-2">
                    <span class="material-symbols-outlined text-lg text-[#4a4a51] leading-none mb-px">source</span>
                    <span class="leading-none text-[15px] font-medium text-gray-800">{{ fullDetails?.source | titlecase
                        }}</span>
                </div>
            </div>

            <!-- Created At -->
            <div>
                <p class="text-[13px] text-[#808080] mb-2 leading-none font-medium">Created At</p>
                <div class="flex items-center gap-2">
                    <span
                        class="material-symbols-outlined text-lg text-[#4a4a51] leading-none mb-px">calendar_month</span>
                    <span class="leading-none text-[15px] font-medium text-gray-800">{{ convertToLocal(fullDetails?.created_at ||
                        requestDetails?.created_at) | date:'MMM d, y, h:mm a' }}</span>
                </div>
            </div>

            <!-- Updated At -->
            <div>
                <p class="text-[13px] text-[#808080] mb-2 leading-none font-medium">Updated At</p>
                <div class="flex items-center gap-2">
                    <span
                        class="material-symbols-outlined text-lg text-[#4a4a51] leading-none mb-px">calendar_month</span>
                    <span class="leading-none text-[15px] font-medium text-gray-800">{{ convertToLocal(fullDetails?.updated_at ||
                        requestDetails?.updated_at) | date:'MMM d, y, h:mm a' }}</span>
                </div>
            </div>

            <!-- Subject (Full width) -->
            <div class="col-span-2">
                <p class="text-[13px] text-[#808080] mb-2 leading-none font-medium">Subject</p>
                <p class="leading-none text-[15px] font-medium text-gray-800 m-0">
                    {{ fullDetails?.subject || requestDetails?.subject }}
                </p>
            </div>

            <!-- Description (Full width) -->
            <div class="col-span-2">
                <p class="text-[13px] text-[#808080] mb-2 leading-none font-medium">Description</p>
                <div class="p-[10px] border border-slate-200 border-solid bg-slate-50 rounded-md">
                    <p class="text-[14px] font-medium text-gray-800 m-0 whitespace-pre-wrap">
                        {{ fullDetails?.description }}
                    </p>
                </div>
            </div>

            <!-- Team Updates -->
            <div class="col-span-2" *ngIf="fullDetails?.visible_update">
                <p class="text-[13px] text-[#808080] mb-2 leading-none font-medium">Team Update</p>
                <div class="p-[10px] border border-slate-200 border-solid bg-[#f0f9ff] rounded-md">
                    <p class="text-[14px] font-medium text-gray-800 m-0 whitespace-pre-wrap">
                        {{ fullDetails.visible_update }}
                    </p>
                </div>
            </div>
        </div>
    </div>

    <!-- Loading State -->
    <div class="flex-1 overflow-y-auto p-4" *ngIf="isLoading">
        <ngx-skeleton-loader count="8" [theme]="{ 'border-radius': '6px', height: '40px', 'margin-bottom': '16px'}">
        </ngx-skeleton-loader>
    </div>

    <!-- No Data Placeholder -->
    <div class="flex-1 flex flex-col items-center justify-center p-12 text-center"
        *ngIf="!requestDetails && !isLoading">
        <img src="assets/images/empty_list.png" class="w-32 opacity-40 mb-4" />
        <p class="text-gray-400 text-sm">Select a request to view details</p>
    </div>
</div>